<template>
  <div class="pw_notification" :class="`pw_notification--${type}`">
    <div class="pw_notification__close" @click="() => $emit('destroyed', id)">
      <i class="mdi mdi-close"></i>
    </div>
    <div class="pw_side">
      <i class="mdi" :class="icon"></i>
    </div>
    <div class="pw_notification-text">
      <h2>{{ title || messages[type] }}</h2>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
      default: 'success',
    },
    title: {
      type: String,
    },
    message: {
      type: String,
      default: 'success',
    },
    duration: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      messages: {
        success: 'Acción realizada exitosamente',
        warning: 'Acción no realizada correctamente',
        danger: 'Error al realizar acción',
      },
    };
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'mdi-check-circle-outline';
        case 'warning':
          return 'mdi-alert-outline';
        case 'danger':
          return 'mdi-alert-circle-outline';

        default:
          return 'mdi-check-circle-outline';
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$emit('destroyed', this.id);
    }, this.duration);
  },
  i18n: {
    messages: {
      'es-MX': {
        success: 'Acción realizada exitosamente',
        warning: 'Acción no realizada correctamente',
        danger: 'Error al realizar acción',
      },
    },
  },
};
</script>

<style lang="scss">
.pw_notification {
  &__close {
    position: absolute;
    right: 3px;
    top: 3px;
    cursor: pointer;
    color: #d8e3eb;
  }
  display: flex;
  width: 100%;
  background-color: #fff;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
  .pw_side {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
  border: 1px solid white;
  border-radius: 4px;
  &--success {
    border-color: #19bf95;
    .pw_side {
      background-color: #19bf95;
    }
  }
  &--warning {
    border-color: #ffc848;
    .pw_side {
      background-color: #ffc848;
    }
  }
  &--danger {
    border-color: #f25555;
    .pw_side {
      background-color: #f25555;
    }
  }
}
.pw_notification-text {
  padding: 12px;
  width: calc(100% - 40px);
  h2 {
    font-size: 14px;
    margin-top: 0;
    line-height: 22px;
    margin-bottom: 3px;
    font-weight: 700;
  }
  p {
    font-size: 12px;
    margin-bottom: 0;
    line-height: 15px;
    margin-top: 0;
  }
}
</style>
